import React, { ReactElement } from 'react'

import { InfoPlaceholder, SectionList, SectionListItem } from 'Components'

type Props<T> = {
  sectionList: SectionListItem<T>[]
  searchQuery: string
  getName: (item: T) => string
  itemTypeName: string
  renderCard: (item: T) => ReactElement
}

export const FavoritesFilteredSectionList = <T,>({
  sectionList,
  searchQuery,
  getName,
  itemTypeName,
  renderCard
}: Props<T>): ReactElement => {
  if (!sectionList.length) {
    return <InfoPlaceholder text={`Keine ${itemTypeName} favorisiert.`} />
  }

  const normalizedQuery = searchQuery.trim().toLowerCase()

  const filteredSectionList = !normalizedQuery
    ? sectionList
    : sectionList
        .map((section) => ({
          ...section,
          data: section.data.filter((item) => getName(item).toLowerCase().includes(normalizedQuery))
        }))
        .filter((section) => section.data.length > 0)

  if (!filteredSectionList.length) {
    return (
      <InfoPlaceholder
        title="Keine passenden Ergebnisse"
        text={`Keine passenden favorisierten ${itemTypeName} gefunden.`}
      />
    )
  }

  return <SectionList<T> sectionList={filteredSectionList} renderCard={renderCard} />
}
